/* eslint no-unused-vars: 1 */

(function() {
    'use strict';
    angular.module('shopAuth', [ 'ngSanitize'
    ]);
})();

/**
 * hard copy of OLS R30.4 auth slightly modificated in case R30 will be used it must partly changed introduced to avoid trouble with R30
 */
(function() {
    'use strict';
    angular.module('shopAuth', [ 'mnp.config'
    ]).config(['$compileProvider', '$httpProvider', function myAppConfig($compileProvider, $httpProvider) {
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|javascript):/);
        $httpProvider.interceptors.push('authHttpResponseInterceptor');
    }]).factory('authHttpResponseInterceptor', [ '$q', '$injector', function($q, $injector) {
        var config = $injector.get('config');
        var setBshopCookie = function(token) {
            var deferred = $q.defer();
            var $http = $injector.get('$http');
            var setCookie = $http({
                method: 'GET',
                url: config.COOKIESET.BSHOPURL,
                headers: {
                    'x-vf-bshoptoken': token
                },
            }).then(function(result) {
                deferred.resolve();
            }, function(error) {
                deferred.reject({
                    'error': 'something went wrong'
                });
            });
            return deferred.promise;
        };
        var getToken = function() {
            var $http = $injector.get('$http');
            var deferred = $q.defer();
            $http({
                method: 'POST',
                timeout: 20000,
                cache: false,
                headers: {
                    'Authorization': 'Basic MmRqbXdDemlBbGk1ZkI2UEtCc0FnWnJ1OVhHOTNqdEU6RTNMdUlWV2MzUWFuMmoxVQ==',
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: {
                    grant_type: 'client_credentials', // eslint-disable-line camelcase
                    apix_opcoid: '49', // eslint-disable-line camelcase
                    scope: 'bshop_all'
                },
                transformRequest: function(obj) {
                    var str = [];
                    for ( var p in obj) {
                        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
                    }
                    return str.join('&');
                },
                url: config.SELTOKEN.URL
            }).then(function(response) {
                var accessToken = response.data.access_token;
                deferred.resolve(accessToken);
            });
            return deferred.promise;
        };
        var setSelToken = function(token) {
            var $http = $injector.get('$http');
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: config.COOKIESET.SELURL,
                headers: {
                    'x-vf-seltokenbshop': token
                },
            }).then(function() {
                deferred.resolve();
            });
            return deferred.promise;
        };
        return {
            response: function(response) {
                var deferred = $q.defer();
                if (!config.isUrlApiUrl(response.config.url)) {
                    deferred.resolve(response);
                } else {
                    var token = response.headers()[config.COOKIESET.HEADERFLAG];
                    if (token && '' !== token) {
                        var qResult = setBshopCookie(token).then(function(result) {
                            deferred.resolve(response);
                        }, function(error) {
                            deferred.resolve(response);
                        });
                    } else {
                        deferred.resolve(response);
                    }
                }
                return deferred.promise;
            },
            responseError: function(rejection) {
                if (403 === rejection.status && config.isUrlApiUrl(rejection.config.url)) {
                    var deferred = $q.defer();
                    var promiseSel = deferred.promise;
                    var $http = $injector.get('$http');
                    getToken().then(function(token) {
                        setSelToken(token).then(function() {
                            deferred.resolve();
                        });
                    });
                    var promiseUpdate = promiseSel.then(function() {
                        return $http(rejection.config);
                    });
                    return promiseUpdate;
                }
                return $q.reject(rejection);
            }
        };
    }

    ]);
}());

(function() {
    'use strict';
    angular.module('shopAuth').directive('ngEnter', function() {
        return function(scope, element, attrs) {
            element.on('keydown keypress', function(event) {
                if (13 === event.which) {
                    scope.$apply(function() {
                        scope.$eval(attrs.ngEnter, {
                            'event': event
                        });
                    });
                    event.preventDefault();
                }
            });
        };
    });
})();
